import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { supabase } from '../supabase';
import { getUser } from '../auth';

export default function Invite() {
  const navigate = useNavigate();
  const { prenom } = useParams();
  const user = getUser();
  const [activites, setActivites] = useState([]);
  const [stats, setStats] = useState({ users: 0, activites: 0 });
  const [visible, setVisible] = useState(false);
  const [parrain, setParrain] = useState(null);

  useEffect(() => {
    setTimeout(() => setVisible(true), 200);
    fetchActivites();
    fetchStats();
    if (prenom) fetchParrain();
  }, []);

  const fetchParrain = async () => {
    const { data } = await supabase.from('users').select('id, prenom, avatar_url, nb_filleuls').ilike('prenom', prenom).single();
    if (data) setParrain(data);
  };

  const fetchActivites = async () => {
    const today = new Date().toISOString().split('T')[0];
    const { data } = await supabase.from('activites').select('*').gte('date', today).order('date', { ascending: true }).limit(3);
    if (data) setActivites(data);
  };

  const fetchStats = async () => {
    const [{ count: users }, { count: acts }] = await Promise.all([
      supabase.from('users').select('*', { count: 'exact', head: true }),
      supabase.from('activites').select('*', { count: 'exact', head: true }),
    ]);
    setStats({ users: users || 0, activites: acts || 0 });
  };

  const lienInscription = prenom
    ? `https://wooki.app/inscription?parrain=${encodeURIComponent(prenom)}`
    : 'https://wooki.app/inscription';

  return (
    <div style={{ minHeight: '100vh', background: '#FAFAF7', overflowX: 'hidden' }}>
      <style>{`
        @keyframes slideUp{from{transform:translateY(30px);opacity:0}to{transform:translateY(0);opacity:1}}
        @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}
        @keyframes pulse{0%,100%{box-shadow:0 8px 32px rgba(61,154,106,0.4)}50%{box-shadow:0 8px 48px rgba(61,154,106,0.65)}}
        @keyframes blob{0%,100%{transform:translate(0,0) scale(1)}50%{transform:translate(20px,-15px) scale(1.05)}}
      `}</style>

      {/* HERO */}
      <div style={{ background: 'linear-gradient(160deg, #1C2B1E, #2D7A52)', padding: '60px 24px 48px', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', width: 300, height: 300, borderRadius: '50%', background: 'radial-gradient(circle, #52C289, transparent)', opacity: 0.15, top: -80, right: -60, animation: 'blob 8s ease-in-out infinite' }} />
        <div style={{ position: 'absolute', width: 200, height: 200, borderRadius: '50%', background: 'radial-gradient(circle, #FF7043, transparent)', opacity: 0.1, bottom: -40, left: -40, animation: 'blob 10s ease-in-out infinite' }} />

        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ fontSize: '4rem', marginBottom: 16, animation: visible ? 'float 3s ease-in-out infinite' : 'none', display: 'inline-block' }}>🌿</div>

          {/* PARRAIN */}
          {parrain ? (
            <div style={{ animation: visible ? 'slideUp 0.6s ease 0.1s both' : 'none' }}>
              {parrain.avatar_url && (
                <div style={{ width: 72, height: 72, borderRadius: '50%', overflow: 'hidden', border: '3px solid rgba(255,255,255,0.3)', margin: '0 auto 12px' }}>
                  <img src={parrain.avatar_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
              )}
              <div style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.7)', marginBottom: 8, fontWeight: 700 }}>
                {parrain.prenom} t'invite sur
              </div>
              <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '2.8rem', marginBottom: 6 }}>
                <span style={{ color: '#52C289' }}>Woo</span><span style={{ color: '#FF7043' }}>ki</span>
              </div>
            </div>
          ) : (
            <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '2.8rem', marginBottom: 6, animation: visible ? 'slideUp 0.6s ease 0.1s both' : 'none' }}>
              <span style={{ color: '#52C289' }}>Woo</span><span style={{ color: '#FF7043' }}>ki</span>
            </div>
          )}

          <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.8rem', color: 'white', marginBottom: 12, animation: visible ? 'slideUp 0.6s ease 0.2s both' : 'none', lineHeight: 1.2 }}>
            Tes copains<br /><span style={{ color: '#A8E6C3' }}>t'attendent !</span>
          </div>

          <div style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.8)', lineHeight: 1.7, marginBottom: 28, animation: visible ? 'slideUp 0.6s ease 0.3s both' : 'none' }}>
            Sorties en plein air pour tes enfants.<br />Gratuit, simple, sécurisé 🌿
          </div>

          {/* STATS */}
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginBottom: 28, animation: visible ? 'slideUp 0.6s ease 0.4s both' : 'none' }}>
            {[
              { val: stats.users, label: 'familles', color: '#A8E6C3' },
              { val: stats.activites, label: 'activités', color: '#FFB347' },
            ].map((s, i) => (
              <div key={i} style={{ background: 'rgba(0,0,0,0.3)', borderRadius: 14, padding: '10px 20px', textAlign: 'center', border: '1px solid rgba(255,255,255,0.15)', minWidth: 90 }}>
                <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.5rem', color: s.color }}>{s.val}</div>
                <div style={{ fontSize: '0.65rem', color: 'rgba(255,255,255,0.7)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>{s.label}</div>
              </div>
            ))}
          </div>

          <div style={{ animation: visible ? 'slideUp 0.6s ease 0.5s both' : 'none' }}>
            <button onClick={() => navigate(lienInscription.replace('https://wooki.app', ''))} style={{ width: '100%', maxWidth: 340, padding: '18px', background: '#3D9A6A', color: 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 900, fontSize: '1.05rem', cursor: 'pointer', animation: 'pulse 2.5s ease-in-out infinite', marginBottom: 12, display: 'block', margin: '0 auto 12px', boxShadow: '0 8px 32px rgba(61,154,106,0.4)' }}>
              🌿 Je rejoins Wooki — c'est gratuit !
            </button>
            <button onClick={() => navigate('/feed')} style={{ width: '100%', maxWidth: 340, padding: '13px', background: 'rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.85)', border: '1.5px solid rgba(255,255,255,0.25)', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.88rem', cursor: 'pointer', display: 'block', margin: '0 auto' }}>
              Voir les activités →
            </button>
          </div>
        </div>
      </div>

      {/* POURQUOI WOOKI */}
      <div style={{ padding: '36px 24px 24px' }}>
        <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.4rem', color: '#1C2B1E', marginBottom: 20, textAlign: 'center' }}>
          Pourquoi Wooki ? 🌿
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 24 }}>
          {[
            { emoji: '🆓', title: '100% gratuit', desc: 'Pas d\'abo, pas de pub.', bg: '#EDF7F1' },
            { emoji: '👨‍👩‍👧', title: 'Parents présents', desc: 'Sécurité garantie.', bg: '#FFF3EE' },
            { emoji: '📍', title: 'Près de toi', desc: 'Géolocalisé.', bg: '#EEF4FF' },
            { emoji: '🌿', title: 'Plein air', desc: 'Forêt, parc, sport...', bg: '#FFFBE6' },
          ].map((f, i) => (
            <div key={i} style={{ background: f.bg, borderRadius: 20, padding: '16px 14px', textAlign: 'center' }}>
              <div style={{ fontSize: '1.8rem', marginBottom: 8 }}>{f.emoji}</div>
              <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '0.88rem', color: '#1C2B1E', marginBottom: 4 }}>{f.title}</div>
              <div style={{ fontSize: '0.73rem', color: '#8A9E8D', lineHeight: 1.4 }}>{f.desc}</div>
            </div>
          ))}
        </div>

        {/* ACTIVITÉS */}
        {activites.length > 0 && (
          <div style={{ marginBottom: 24 }}>
            <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.1rem', color: '#1C2B1E', marginBottom: 14 }}>🌟 Activités près de toi</div>
            {activites.map((a, i) => (
              <div key={a.id} onClick={() => navigate(`/detail/${a.id}`)}
                style={{ background: 'white', borderRadius: 20, padding: '14px 16px', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 12, boxShadow: '0 4px 16px rgba(28,43,30,0.07)', cursor: 'pointer' }}>
                <div style={{ width: 48, height: 48, borderRadius: 16, background: '#EDF7F1', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', flexShrink: 0 }}>{a.emoji}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '0.92rem', color: '#1C2B1E', marginBottom: 3 }}>{a.titre}</div>
                  <div style={{ fontSize: '0.72rem', color: '#8A9E8D' }}>
                    {new Date(a.date).toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' })} · {a.heure?.slice(0,5)} · {a.lieu?.split(',')[0]}
                  </div>
                </div>
                <div style={{ color: '#3D9A6A', fontSize: '0.9rem' }}>→</div>
              </div>
            ))}
          </div>
        )}

        {/* CTA FINAL */}
        <div style={{ background: 'linear-gradient(135deg, #1C2B1E, #2D7A52)', borderRadius: 24, padding: '24px', textAlign: 'center' }}>
          <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.3rem', color: 'white', marginBottom: 8 }}>
            {parrain ? `Rejoins ${parrain.prenom} sur Wooki !` : 'Rejoins Wooki !'}
          </div>
          <div style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.7)', marginBottom: 20, lineHeight: 1.6 }}>
            Gratuit. Sécurisé. Bienveillant.
          </div>
          <button onClick={() => navigate(lienInscription.replace('https://wooki.app', ''))} style={{ width: '100%', padding: '16px', background: '#3D9A6A', color: 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 900, fontSize: '1rem', cursor: 'pointer', marginBottom: 10, boxShadow: '0 6px 20px rgba(61,154,106,0.4)' }}>
            🌿 Créer mon compte gratuit
          </button>
          <button onClick={() => navigate('/connexion')} style={{ width: '100%', padding: '13px', background: 'transparent', color: 'rgba(255,255,255,0.7)', border: '1.5px solid rgba(255,255,255,0.2)', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.88rem', cursor: 'pointer' }}>
            J'ai déjà un compte →
          </button>
        </div>
      </div>
    </div>
  );
}